import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes with tailwind-merge to handle conflicts
 * 
 * Usage:
 * cn('px-4 py-2', condition && 'bg-primary', className)
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
